const changePassword = {
  title: "Change",
  subTitle: "password",
  labels: {
    oldPassword: "Old password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password"
  },
  placeholders: {
    oldPassword: "Enter your old password",
    newPassword: "Enter your new password",
    confirmNewPassword: "Confirm new password"
  },
  actionBTN: "Save"
};

export default changePassword;
